import { createContext } from "react";
import { Publication } from '../interfaces/Publication';

export type PublicationContextProps = {
    publication: Publication
    changePublication: (publication:Publication) => void
}

export const PublicationContext = createContext<PublicationContextProps>({ } as PublicationContextProps);